var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LaunchModule',{attrs:{"module-data":_vm.data,"data-luko-tracking":"Page-Launch_uid"}})}
var staticRenderFns = []

export { render, staticRenderFns }